export default __webpack_public_path__ + "static/media/xdrive_frame.e29297b0.webp";